<template>
  <div v-resize="onResize" class="nav-header w-full h-full">
    <div
      class="d-flex align-center h-full"
      style="border-bottom: 2px solid #e3e1e1; background: #fff"
    >
      <h4 class="mx-3" style="color: #e47911 !important; width: 40px">Est.</h4>
      <v-menu
        ref="refMenu"
        offset-y
        eagers
        color="transparent"
        :open-on-hover="false"
        attach
        class="horizontal-nav-header-group"
        content-class="list-style elevation-0"
      >
        <template #activator="{ on, attrs }">
          <v-btn
            ref="refActivator"
            depressed
            large
            style="
              font-size: 13px !important;
              min-width: 200px;
              max-width: 200px;
              border-left: 1px solid #e3e1e1 !important;
              border-right: 1px solid #e3e1e1 !important;
            "
            tile
            color="transparent"
            dark
            v-bind="attrs"
            class="text-capitalize text-base px-5 mr-0 tab-button text--primary"
            :class="[{ 'menu-open': isMenuActive }]"
            v-on="on"
          >
            <span class="mr-3">{{ menuTabTitle.attribute }}</span>
            <v-icon size="20">
              {{ icons.mdiChevronDown }}
            </v-icon>
          </v-btn>
        </template>
        <v-list
          ref="refContent"
          :elevation="$vuetify.theme.dark ? 9 : 8"
          class="primary white--text"
        >
          <v-list-item-group>
            <MenuLink
              v-for="child in navMenuItems.children"
              :key="child.subheader || child.title"
              :item="child"
              @consolePersistant="consolePersistant"
            ></MenuLink>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <ul
        v-if="isVisible && !fixedTabMenuTitles.includes(menuTabTitle.attribute)"
        class="nav-ul d-flex flex-grow-1"
      >
        <TabHeaderLink
          v-for="(item, index) in tabs"
          :key="index"
          class="justify-center"
          :item="item"
          :loading="loading"
          active-module="estimation"
          @tabClick="tabClick"
          @closeTab="closeTab"
          @onResize="onResize"
        />
      </ul>
      <ul
        v-if="isFixedVisible && fixedTabMenuTitles.includes(menuTabTitle.attribute)"
        class="nav-ul d-flex flex-grow-1"
      >
        <EstimateFixTab
          v-for="(item, index) in fixedTabs"
          :key="index"
          class="justify-center"
          :item="item"
          :pinned="true"
          active-module="estimation"
          @tabClick="tabFixClick"
          @onResize="onFixedResize"
        />
      </ul>
      <MoreTabMenu
        v-if="more.length && !fixedTabMenuTitles.includes(menuTabTitle.attribute)"
        class="flex-grow-1"
        :more="more"
        @addItem="addItem"
        @closeTab="closeTab"
        @onResize="onResize"
      />
      <FixedMoreMenu
        v-if="fixedMore.length && !fixedTabMenuTitles.includes(menuTabTitle.attribute)"
        class="flex-grow-1"
        :more="fixedMore"
        :pinned="true"
        @addItem="addItem"
        @onResize="onFixedResize"
      />
    </div>
  </div>
</template>

<script>
import navMenuItems from '@/navigation/estimation'
import { computed, ref, nextTick, watch, watchEffect } from '@vue/composition-api'
import { storeGetters, storeActions } from '@/store/storeConstants'
import store from '@/store'
import { useRouter } from '@core/utils'
import MenuLink from '@core/layouts/components/horizontal-tab-menu/components/set-up/MenuLink.vue'
import { mdiChevronDown } from '@mdi/js'
import estimateSchema from '@/schema/estimateSchema'
import EstimateFixTab from '@core/layouts/components/horizontal-tab-menu/components/EstimateFixTab.vue'
import MoreTabMenu from './components/MoreTabMenu.vue'
import TabHeaderLink from './components/TabHeaderLink.vue'
import FixedMoreMenu from './components/FixedMoreMenu.vue'
import HorizontalTabMenuHeaderGroup from './components/horizontal-tab-menu-header-group/HorizontalTabMenuHeaderGroup.vue'

export default {
  name: 'EstimateMenu',
  components: {
    TabHeaderLink,
    MoreTabMenu,
    MenuLink,
    EstimateFixTab,
    FixedMoreMenu,
    HorizontalTabMenuHeaderGroup,
  },
  methods: {
    goto() {
      console.log('goto tab')
    },
    close() {
      console.log('hit')
    },
    pin() {
      console.log('pin')
    },
  },
  setup() {
    const { GET_ESTIMATION_TABS, GET_ESTIMATE_PERSIST_TAB } = storeGetters
    const { router } = useRouter()

    const tabs = ref([])
    const more = ref([])
    const isVisible = ref(true)
    const isFixedVisible = ref(true)

    const fixedTabMenuTitles = ref(['Calculator Configuration', 'Quote Configuration'])

    const loadMore = () => {
      const payload = {
        component: 'setup/user-preferences',
        key: 'estimation',
        filter: {
          key: 'estimation',
        },
      }
      store.dispatch(`tabSystem/${storeActions.FETCH_TABS}`, payload)
    }

    loadMore()

    const loading = computed(() => store.getters[`tabSystem/${storeGetters.TAB_LOADING}`])
    const totalTabs = computed(() => store.getters[`tabSystem/${GET_ESTIMATION_TABS}`])
    const menuTabTitle = computed(() => store.getters[`setupTab/${GET_ESTIMATE_PERSIST_TAB}`])
    // const subTabArr = computed(() => store.getters[`tabs/${GET_SUB_TAB}`])

    const onResize = () => {
      isVisible.value = false
      const temp = totalTabs.value.slice()
      tabs.value = temp.splice(0, (window.innerWidth - 234) / 190 - 1)
      more.value = temp.splice(0)
      nextTick(() => {
        isVisible.value = true
      })
    }

    const addItem = item => {
      const payload = {
        item,
        key: 'estimation',
        prop_type: 'estimate',
        component: 'setup/user-preferences',
      }
      store.dispatch(`tabSystem/${storeActions.TAB_POSITION_CHANGE}`, payload)

      router.push({ name: item.to, params: { uuid: item.key } }).catch(() => {})
      onResize()
    }

    const tabClick = item => {
      router.push({ name: item.to, params: { uuid: item.key } }).catch(() => {})
    }
    const tabFixClick = item => {
      router.push({ name: item.to }).catch(() => {})
    }

    const addTab = () => {
      onResize()
    }
    const consolePersistant = item => {
      const menuTab = {
        attribute: item.title,
      }
      store.dispatch(`setupTab/${storeActions.ESTIMATE_TAB_REQUEST}`, menuTab)
    }

    // const closeTab = item => {
    //   store.commit('tabPersist/RESET_TOGGLE_DROPDOWN')
    //   store.dispatch(`tabs/${storeActions.CANCEL_TAB_REQUEST}`, item)
    //   onResize()
    // }
    const closeTab = ({ item, isActive }) => {
      const payload = {
        item,
        key: 'estimation',
        component: 'setup/user-preferences',
        prop_type: 'estimate',
      }
      store.dispatch(`tabSystem/${storeActions.CANCEL_TAB_REQUEST}`, payload)
      // store.commit('tabPersist/RESET_TOGGLE_DROPDOWN')

      if (isActive) {
        // redirect when active tab is closed
        if (totalTabs.value.length) {
          const redirectTab = totalTabs.value[0]
          router
            .push({
              name: redirectTab.to,
              params: { uuid: redirectTab.key },
            })
            .catch(() => {})
        } else {
          router.push({ name: 'estimation-dashboard' })
        }
      }

      onResize()
    }

    watch(
      () => totalTabs.value,
      () => {
        addTab()
      },
    )

    const refMenu = ref(null)
    const isMenuActive = ref(false)
    watchEffect(() => {
      isMenuActive.value = refMenu.value ? refMenu.value.isActive : false
    })

    const fixedTabs = ref([])
    const fixedMore = ref([])
    const menuFixedTabTitle = computed(() => store.getters[`setupTab/${GET_ESTIMATE_PERSIST_TAB}`])

    const totalFixedTabs = computed(() => {
      const tab = menuFixedTabTitle.value.attribute
      if (tab && estimateSchema.headerTabs[tab]) {
        return estimateSchema.headerTabs[tab].tabs
      }

      if (tab == 'Calculator Configuration'){
        return estimateSchema.headerTabs.configuration.tabs
      }

      return estimateSchema.headerTabs.quote_configuration.tabs
    })

    const onFixedResize = () => {
      isFixedVisible.value = false
      const temp = totalFixedTabs.value.slice()
      fixedTabs.value = temp.splice(0, (window.innerWidth - 234) / 190 - 1)
      fixedMore.value = temp.splice(0)
      nextTick(() => {
        isFixedVisible.value = true
      })
    }

    const addFixedItem = item => {
      router.push({ name: item.to }).catch(() => {})
      onFixedResize()
    }

    watch(
      () => totalFixedTabs.value,
      () => {
        onFixedResize()
      },
    )

    return {
      tabs,
      more,
      isVisible,
      isFixedVisible,
      fixedTabMenuTitles,
      closeTab,
      consolePersistant,
      onResize,
      loading,
      addItem,
      addFixedItem,
      tabClick,
      fixedTabs,
      fixedMore,
      onFixedResize,
      tabFixClick,
      isMenuActive,
      menuTabTitle,
      navMenuItems,
      icons: {
        mdiChevronDown,
      },
    }
  },
}
</script>
<style scoped>
.nav-ul {
  padding: 0px !important;
}
</style>
